import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

/**
 * Fase 1L.13G — Recuperação de senha (solicitação).
 *
 * A resposta genérica após o envio impede enumeração de contas. O
 * contrato do endpoint ``POST /auth/forgot-password`` (payload
 * ``{email}``, resposta 200) permanece inalterado.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Recuperar senha</h1>
        <p className="text-sm text-slate-500 mt-1">Enviaremos um link de redefinição por e-mail.</p>
        {sent ? (
          <div
            data-testid="forgot-success"
            role="status"
            aria-live="polite"
            className="mt-6 p-4 bg-emerald-50 border border-emerald-200 rounded-lg text-sm text-emerald-800"
          >
            Se houver uma conta vinculada a este e-mail, você receberá as instruções para redefinir sua senha.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="forgot-form">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5" htmlFor="forgot-email">E-mail</label>
              <input
                id="forgot-email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input"
                className="w-full h-10 rounded-lg border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
              />
            </div>
            {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="forgot-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-button"
              className="w-full h-10 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 disabled:opacity-50"
            >
              {loading ? "Enviando..." : "Enviar instruções"}
            </button>
          </form>
        )}
        <p className="text-sm text-slate-500 mt-6 text-center">
          <Link to="/login" className="hover:underline" data-testid="forgot-back-to-login">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
}
